<!--
 * @Author: your name
 * @Date: 2025-05-26 19:59:01
 * @LastEditTime: 2025-05-27 21:17:11
 * @LastEditors: niuzijie
 * @Description: In User Settings Edit
 * @FilePath: \yl-wxcx-coupon-front\src\views\checkGoods\sendDetail.vue
-->
<template>
  <div class="sendDetail">
    <div v-if="emptyState" class="empty-box">
      <div class="cgs-null">
        <img class="cgs-img" src="https://cms.jtexpress.com.cn/images/miniprogram/default/no-package.png" alt="" />
        <div class="cgs-text">未查询到运单信息</div>
        <div class="cgs-text">仅只支持查询12个月内的运单</div>
      </div>
    </div>
    <!-- 轨迹组件 -->
    <logisticsTracking
      v-else
      :waybillNo="waybillNo"
      :bsFlag="bsFlag"
      :routeList="waybillDetail.details"
      :exceptionToast="exceptionToast"
      />
    <!-- 滑块验证组件 -->
    <Verify
      ref="verify"
			style="z-index: 99999;"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      @success="success"
      />
  </div>
</template>

<script>
import logisticsTracking from './components/logisticsTracking'
import Verify from './components/verifition/Verify'
import { getWaybillApi } from '@/api'

export default {
  components: {
    logisticsTracking,
    Verify,
  },
  data () {
    return {
      COM_HTTP: getWaybillApi,
      waybillNo: '',
      bsFlag: false,
      waybillDetail: {
        details: null,
      },
      exceptionToast: '',
      emptyState: false,
    }
  },
  created () {
    const { waybillNo } = this.$route.query
    if (!waybillNo) return
    this.waybillNo = waybillNo
    if (this.waybillNo && this.waybillNo.substr(0, 2) === '55') {
      this.bsFlag = true
    }
  },
  mounted() {
    if (!this.waybillNo) {
      this.$toast.fail({
        message: '运单号不能为空',
        duration: 2000,
      })
      this.emptyState = true
      return
    }
    this.$nextTick(() => {
      this.$refs.verify.show()
    })
  },
  methods: {
    // 验证成功的回调函数
    success(params) {
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.getWaybillDetail(params)
    },
    // 调用接口获取运单详情
    async getWaybillDetail({ captchaVerification }) {
      try {
        this.$toast.loading({
          message: '加载中...',
          duration: 0,
          forbidClick: true,
        })
        const params = {
          captchaVerification,
          waybillNo: this.waybillNo,
        }
        this.emptyState = false
        const { code, data, msg } = await this.COM_HTTP.getWaybillDetailAndUser(params)
        console.log('🚀 ~ getWaybillDetail ~ code, data, msg:', code, data, msg)
        this.$toast.clear()
        if (code === 1) {
          if (!data.details || !data.details.length) {
            this.emptyState = true
            return
          }
          data.details.forEach(item => {
            // 对时间的秒进行过滤
            item.scanTime = item.scanTime.trim().slice(0, -3)
          })
          this.waybillDetail = data
        } else {
          this.emptyState = true
          this.$toast.fail({
            message: msg,
            duration: 2000,
          })
        }
      } catch (error) {
        console.log('🚀 ~ getWaybillDetail ~ error:', error)
        this.emptyState = true
        this.$toast.clear()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.empty-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  .cgs-null {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    margin:250rpx auto 0;
      .cgs-img {
        width: 440rpx;
        height: 440rpx;
      }
      .cgs-text {
        width: 100%;
        color: #999999;
        text-align: center;
        padding-top: 4rpx;
        font-size: 28rpx;
      }
  }
}
</style>

